import React from 'react';

import { type IntlShape } from 'react-intl-next';

import { aiDefinitionsMessages } from '@atlaskit/editor-common/messages';
import {
	type Command,
	type ExtractInjectionAPI,
	type FloatingToolbarButton,
} from '@atlaskit/editor-common/types';
import { type EditorState } from '@atlaskit/editor-prosemirror/state';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import { AtlassianIcon, RovoIcon } from '@atlaskit/logo';

import { openReadingAidsPopup } from '../../pm-plugins/ai-definitions/commands';
import type { AIDefinitionsPlugin, AIDefinitionsPluginConfig } from '../../types';
import { getReadingAidsSelectionProps } from '../../ui/DefineModal/utils';
import { selectionExceedsMaxWordCount } from '../../utils/selection';

export const getAIDefineButton = ({
	intl,
	state,
	config,
	api,
}: {
	intl: IntlShape;
	state: EditorState;
	config: AIDefinitionsPluginConfig;
	api: ExtractInjectionAPI<AIDefinitionsPlugin>;
}) => {
	const disabled = selectionExceedsMaxWordCount(state, config);
	const selectionProps = getReadingAidsSelectionProps(state);

	return {
		title: intl.formatMessage(aiDefinitionsMessages.aiDefineToolbarButtonTitle),
		type: 'button',
		showTitle: true,
		testId: 'ak-editor-ai-selection-toolbar-ai-button',
		icon: () =>
			config.enablementSource === 'rovo' ? <RovoIcon size="small" /> : AtlassianIntelligenceIcon,
		iconFallback: AtlassianIcon,
		tooltipContent: disabled
			? intl.formatMessage(aiDefinitionsMessages.aiDefineToolbarButtonDisabledTooltip)
			: undefined,
		disabled: disabled,
		onClick: openReadingAidsPopup({
			// @ts-ignore TODO: Resolve once all type changes settles
			readingAidsPopupProps: {
				...api.aiDefinitions.sharedState.currentState()?.readingAidsPopupProps,
				...selectionProps,
			},
		}),
		supportsViewMode: true,
	} as FloatingToolbarButton<Command>;
};
